import React from 'react';
import { isNil } from 'lodash';
import Anchor from '../Anchor';
import { setDetailPageUrl } from '../../../lib/common';
import { BRAND_DETAIL_URL_PATH } from '../../../constants/service/common/urlConstants';

const OpenBrandDetail = (props) => {
  const { text, storeId } = props;

  /**
   * 링크로 연결할 데이터가 없다면
   * '-' 를 반환함
   */
  if (isNil(text) && isNil(storeId)) {
    return <>-</>;
  }

  return (
    <Anchor
      text={text}
      isUnderLine
      color="primary"
      href={setDetailPageUrl(BRAND_DETAIL_URL_PATH, storeId)}
      target="_blank"
    />
  );
};

export default OpenBrandDetail;
